"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViacomAccountEmailService = exports.viacomAccountEmailService = void 0;
var viacom_account_email_service_1 = require("./viacom-account-email.service");
Object.defineProperty(exports, "viacomAccountEmailService", { enumerable: true, get: function () { return viacom_account_email_service_1.viacomAccountEmailService; } });
Object.defineProperty(exports, "ViacomAccountEmailService", { enumerable: true, get: function () { return viacom_account_email_service_1.ViacomAccountEmailService; } });
